import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const VadeliIslemNedir = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('vadeliIslemNedir.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Uyarı Mesajı - Üstte */}
                <div className="academy-section">
                    <div className="container">
                        <div className="academy-highlight-box ">
                            <h4 className="text-danger">{t('vadeliIslemNedir.warning.title')}</h4>
                            <p className="mb-0 fw-bold">{t('vadeliIslemNedir.warning.text')}</p>
                        </div>
                    </div>
                </div>

                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('vadeliIslemNedir.subtitle')}</h3>
                        <p className="academy-intro-text">{t('vadeliIslemNedir.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('vadeliIslemNedir.intro.p2')}</p>
                        <ul className="academy-list">
                            {t('vadeliIslemNedir.intro.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 1: Vadeli İşlem Nedir? */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('vadeliIslemNedir.section1.title')}</h2>
                        
                        <div className="academy-highlight-box">
                            <h4>{t('vadeliIslemNedir.section1.simpleTitle')}</h4>
                            <p className="mb-0">{t('vadeliIslemNedir.section1.simpleDefinition')}</p>
                        </div>

                        {/* Günlük Hayat Örneği */}
                        <div className="academy-example-box mt-4">
                            <h5>{t('vadeliIslemNedir.section1.realLifeExample.title')}</h5>
                            <p>{t('vadeliIslemNedir.section1.realLifeExample.introo')}</p>
                            {t('vadeliIslemNedir.section1.realLifeExample.steps', { returnObjects: true }).map((step, index) => (
                                <div key={index} className="mb-3">
                                    <strong>{step.title}</strong>
                                    <ul>
                                        {step.items.map((item, iIdx) => (
                                            <li key={iIdx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        {/* Kripto Vadeli İşlem Örneği */}
                        <div className="academy-example-box mt-4">
                            <h5>{t('vadeliIslemNedir.section1.cryptoExample.title')}</h5>
                            <p>{t('vadeliIslemNedir.section1.cryptoExample.intro')}</p>
                            <ul>
                                {t('vadeliIslemNedir.section1.cryptoExample.scenario', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <div className="mt-3">
                                <strong>{t('vadeliIslemNedir.section1.cryptoExample.outcomesTitle')}</strong>
                                {t('vadeliIslemNedir.section1.cryptoExample.outcomes', { returnObjects: true }).map((outcome, index) => (
                                    <div key={index} className="mt-2">
                                        <p className="mb-1">{outcome.case}</p>
                                        <p className="mb-0 ms-3"><span style={{color: outcome.profit? 'green' : 'red'}}>{outcome.result}</span></p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bölüm 2: Long ve Short */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('vadeliIslemNedir.section2.title')}</h2>
                        <p className="academy-section-text">{t('vadeliIslemNedir.section2.intro')}</p>
                        
                        <div className="row g-4">
                            {t('vadeliIslemNedir.section2.positions', { returnObjects: true }).map((position, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-type-card">
                                        <h4>{position.name}</h4>
                                        <p>{position.description}</p>
                                        
                                        <div className="academy-example-box mt-3">
                                            <strong>{t('vadeliIslemNedir.section2.exampleLabel')}</strong>
                                            <ul>
                                                {position.example.map((item, eIdx) => (
                                                    <li key={eIdx}>{item}</li>
                                                ))}
                                            </ul>
                                            
                                            <div className="mt-3">
                                                {position.scenarios.map((scenario, sIdx) => (
                                                    <div key={sIdx} className="mb-3">
                                                        <strong>{scenario.title}</strong>
                                                        <ul className="mb-0">
                                                            {scenario.items.map((item, iIdx) => (
                                                                <li key={iIdx}>{item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Önemli Uyarı */}
                        <div className="academy-highlight-box  text-white mt-4">
                            <h5 className="text-white">{t('vadeliIslemNedir.section2.warning.title')}</h5>
                            <ul className="mb-2">
                                {t('vadeliIslemNedir.section2.warning.points', { returnObjects: true }).map((point, index) => (
                                    <li key={index}>{point}</li>
                                ))}
                            </ul>
                            {t('vadeliIslemNedir.section2.warning.example') && (
                                <p className="mb-0 mt-3 fst-italic">
                                    <small>{t('vadeliIslemNedir.section2.warning.example')}</small>
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Bölüm 3: Avantajlar */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('vadeliIslemNedir.section3.title')}</h2>
                        
                        <div className="row g-4">
                            {t('vadeliIslemNedir.section3.advantages', { returnObjects: true }).map((advantage, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-advantage-card">
                                        <h5>{advantage.title}</h5>
                                        <p>{advantage.description}</p>
                                        {advantage.example && (
                                            <div className="academy-example-box mt-2">
                                                <small>{advantage.example}</small>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bölüm 4: Riskler */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('vadeliIslemNedir.section4.title')}</h2>
                        <p className="academy-section-text">{t('vadeliIslemNedir.section4.intro')}</p>
                        
                        <div className="row g-4">
                            {t('vadeliIslemNedir.section4.risks', { returnObjects: true }).map((risk, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-type-card">
                                        <h5 className="text-danger">{risk.title}</h5>
                                        <p>{risk.description}</p>
                                        {risk.example && (
                                            <div className="academy-example-box mt-2">
                                                <strong>{t('vadeliIslemNedir.section4.exampleLabel')}</strong>
                                                <p className="mb-0 mt-1"><small>{risk.example}</small></p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Son Uyarı */}
                        <div className="academy-highlight-box  text-white mt-5">
                            <h4 className="text-white">{t('vadeliIslemNedir.section4.finalWarning.title')}</h4>
                            <ul className="mb-0">
                                {t('vadeliIslemNedir.section4.finalWarning.points', { returnObjects: true }).map((point, index) => (
                                    <li key={index}>{point}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Özet */}
                <div className="academy-summary-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('vadeliIslemNedir.summary.title')}</h2>
                        <p className="academy-section-text">{t('vadeliIslemNedir.summary.p1')}</p>
                        
                        <div className="row g-4 mt-4">
                            <div className="col-md-6">
                                <div className="academy-type-card">
                                    <h5 className="text-success">{t('vadeliIslemNedir.summary.advantages.title')}</h5>
                                    <ul>
                                        {t('vadeliIslemNedir.summary.advantages.items', { returnObjects: true }).map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="academy-type-card">
                                    <h5 className="text-danger">{t('vadeliIslemNedir.summary.risks.title')}</h5>
                                    <ul>
                                        {t('vadeliIslemNedir.summary.risks.items', { returnObjects: true }).map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="academy-highlight-box mt-4">
                            <h5>{t('vadeliIslemNedir.summary.recommendation.title')}</h5>
                            <p className="mb-0">{t('vadeliIslemNedir.summary.recommendation.text')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default VadeliIslemNedir;
